import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const EmptyStateEmail = ({ height = 128, width = 129, ...props }: SvgIconProps) => (
  <SvgIcon
    height={height}
    width={width}
    viewBox="0 0 129 128"
    data-test="email-empty-state"
    {...props}
  >
    <path
      d="M13.3955 64C13.3955 77.5791 18.7799 90.6021 28.3641 100.204C37.9484 109.806 50.9474 115.2 64.5016 115.2C78.0557 115.2 91.0548 109.806 100.639 100.204C110.223 90.6021 115.608 77.5791 115.608 64C115.608 50.421 110.223 37.398 100.639 27.7962C91.0548 18.1943 78.0557 12.8 64.5016 12.8C50.9474 12.8 37.9484 18.1943 28.3641 27.7962C18.7799 37.398 13.3955 50.421 13.3955 64Z"
      fill={colors.grey5}
    />
    <path
      d="M46.0742 104.78C46.0742 105.425 48.1658 106.044 51.8888 106.501C55.6118 106.958 60.6613 107.214 65.9264 107.214C71.1915 107.214 76.241 106.958 79.964 106.501C83.687 106.044 85.7785 105.425 85.7785 104.78C85.7785 104.134 83.687 103.515 79.964 103.058C76.241 102.601 71.1915 102.345 65.9264 102.345C60.6613 102.345 55.6118 102.601 51.8888 103.058C48.1658 103.515 46.0742 104.134 46.0742 104.78Z"
      fill={colors.grey15}
    />
    <path
      d="M109.51 28.8743C109.511 27.9717 109.333 27.078 108.989 26.244C108.644 25.4101 108.139 24.6523 107.502 24.014C106.865 23.3758 106.108 22.8694 105.276 22.524C104.444 22.1785 103.552 22.0007 102.651 22.0007H29.2114C28.3089 22.0006 27.4153 22.1785 26.5815 22.5244C25.7477 22.8702 24.99 23.3773 24.3518 24.0165C23.7137 24.6558 23.2074 25.4147 22.862 26.2499C22.5166 27.0852 22.3389 27.9805 22.3389 28.8846V77.5745H109.51V28.8743Z"
      fill={colors.cyan10}
    />
    <path
      d="M29.2114 22.0007C28.3089 22.0004 27.4151 22.1782 26.5813 22.524C25.7474 22.8698 24.9897 23.3769 24.3515 24.0161C23.7133 24.6554 23.207 25.4144 22.8617 26.2497C22.5164 27.0851 22.3387 27.9804 22.3389 28.8846V77.5745H65.9259V22.0007H29.2114Z"
      fill={colors.white}
    />
    <path
      d="M76.4927 98.7458H55.3604L56.6814 88.1602H75.1716L76.4927 98.7458Z"
      fill={colors.white}
    />
    <path
      d="M76.4927 98.7458H55.3604L56.6814 88.1602H75.1716L76.4927 98.7458Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M81.0564 104.038H50.7953C50.5225 104.041 50.2533 103.976 50.0122 103.848C49.7711 103.721 49.5656 103.534 49.4146 103.307C49.2635 103.079 49.1716 102.818 49.1472 102.545C49.1228 102.273 49.1667 101.999 49.2749 101.748C49.706 100.849 50.382 100.09 51.2249 99.5588C52.0678 99.0276 53.0434 98.7457 54.0392 98.7456H77.8138C78.8096 98.7457 79.7852 99.0276 80.6281 99.5588C81.471 100.09 82.147 100.849 82.5781 101.748C82.6864 101.999 82.7302 102.274 82.7058 102.546C82.6813 102.818 82.5893 103.08 82.4381 103.307C82.2869 103.535 82.0812 103.721 81.8399 103.849C81.5986 103.976 81.3293 104.042 81.0564 104.038Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M102.423 88.1601C103.354 88.1602 104.276 87.9767 105.136 87.6199C105.996 87.2632 106.777 86.7402 107.435 86.0809C108.093 85.4215 108.615 84.6387 108.971 83.7772C109.327 82.9157 109.511 81.9924 109.51 81.0599V77.5745H22.3389V81.0599C22.3389 81.9924 22.5222 82.9158 22.8785 83.7773C23.2347 84.6388 23.7569 85.4216 24.4151 86.0809C25.0733 86.7403 25.8548 87.2632 26.7148 87.62C27.5748 87.9767 28.4965 88.1602 29.4273 88.1601H102.423Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M109.51 28.8743C109.511 27.9717 109.333 27.078 108.989 26.244C108.644 25.4101 108.139 24.6523 107.502 24.014C106.865 23.3758 106.108 22.8694 105.276 22.524C104.444 22.1785 103.552 22.0007 102.651 22.0007H29.2114C28.3089 22.0006 27.4153 22.1785 26.5815 22.5244C25.7477 22.8702 24.99 23.3773 24.3518 24.0165C23.7137 24.6558 23.2074 25.4147 22.862 26.2499C22.5166 27.0852 22.3389 27.9805 22.3389 28.8846V77.5745H109.51V28.8743Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.7803 55.323H101.232V71.5598H54.7803V55.323Z"
      fill={colors.grey5}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M65.9248 71.5597H99.8222C100.195 71.5597 100.552 71.4113 100.816 71.1473C101.08 70.8832 101.228 70.5251 101.228 70.1517V56.7334C101.228 56.36 101.08 56.0019 100.816 55.7378C100.552 55.4738 100.195 55.3254 99.8222 55.3254H65.9248V71.5597Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M65.9248 65.7346H95.5267"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M65.9248 60.311H95.5267"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.8594 28.0168H101.232V50.0021H28.8594V28.0168Z"
      fill={colors.grey5}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M99.8222 28.0168C100.007 28.0168 100.189 28.0533 100.36 28.124C100.531 28.1948 100.685 28.2985 100.816 28.4292C100.946 28.56 101.05 28.7152 101.121 28.886C101.191 29.0569 101.228 29.2399 101.228 29.4248V48.5864C101.228 48.7713 101.191 48.9544 101.121 49.1253C101.05 49.2961 100.946 49.4513 100.816 49.5821C100.685 49.7128 100.531 49.8165 100.36 49.8873C100.189 49.958 100.007 49.9944 99.8222 49.9944H65.9248V28.0168H99.8222Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M73.9023 50.0022L80.1283 41.2687C80.4701 40.7904 80.9207 40.4007 81.4429 40.1318C81.9651 39.8629 82.5437 39.7227 83.1308 39.7227C83.7179 39.7227 84.2966 39.8629 84.8188 40.1318C85.3409 40.4007 85.7916 40.7904 86.1333 41.2687L92.3593 50.0022H73.9023Z"
      fill={colors.purple10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M89.4531 35.7248C89.4531 36.7158 89.8461 37.6661 90.5455 38.3668C91.2449 39.0675 92.1935 39.4612 93.1826 39.4612C94.1717 39.4612 95.1203 39.0675 95.8197 38.3668C96.5191 37.6661 96.912 36.7158 96.912 35.7248C96.912 34.7339 96.5191 33.7836 95.8197 33.0829C95.1203 32.3822 94.1717 31.9885 93.1826 31.9885C92.1935 31.9885 91.2449 32.3822 90.5455 33.0829C89.8461 33.7836 89.4531 34.7339 89.4531 35.7248Z"
      fill={colors.green10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M65.9253 50.002H83.6553L75.532 39.1502C75.1882 38.6906 74.7423 38.3174 74.2296 38.0605C73.7168 37.8035 73.1514 37.6697 72.5781 37.6697C72.0047 37.6697 71.4393 37.8035 70.9266 38.0605C70.4138 38.3174 69.9679 38.6906 69.6241 39.1502L65.9189 44.0897L65.9253 50.002Z"
      fill={colors.purple10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.8594 55.323H49.16V71.5598H28.8594V55.323Z"
      fill={colors.grey5}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.3193 55.6904L48.7 71.1912"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.3193 71.1912L48.7 55.6904"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M66.012 96.3048C65.2465 96.3086 64.5015 96.0573 63.8942 95.5904C63.287 95.1235 62.852 94.4675 62.6578 93.7257C62.4636 92.9839 62.5212 92.1984 62.8215 91.493C63.1218 90.7876 63.6477 90.2023 64.3165 89.8293V18.9441C63.6508 18.5686 63.128 17.9827 62.8299 17.278C62.5318 16.5733 62.4752 15.7894 62.6689 15.049C62.8626 14.3086 63.2958 13.6534 63.9006 13.1858C64.5055 12.7182 65.248 12.4646 66.012 12.4646C66.776 12.4646 67.5185 12.7182 68.1233 13.1858C68.7282 13.6534 69.1613 14.3086 69.3551 15.049C69.5488 15.7894 69.4922 16.5733 69.1941 17.278C68.896 17.9827 68.3732 18.5686 67.7074 18.9441V89.8293C68.3763 90.2023 68.9022 90.7876 69.2025 91.493C69.5028 92.1984 69.5604 92.9839 69.3662 93.7257C69.172 94.4675 68.737 95.1235 68.1297 95.5904C67.5225 96.0573 66.7775 96.3086 66.012 96.3048Z"
      fill={colors.white}
    />
    <path
      d="M66.012 13.1099C66.6688 13.1035 67.3072 13.3279 67.8161 13.744C68.325 14.16 68.6725 14.7415 68.798 15.3875C68.9236 16.0335 68.8193 16.7031 68.5034 17.2801C68.1875 17.8571 67.6798 18.305 67.0686 18.546V90.226C67.6746 90.4717 68.1765 90.9209 68.4883 91.4966C68.8 92.0723 68.9022 92.7387 68.7773 93.3816C68.6524 94.0245 68.3082 94.6039 67.8037 95.0205C67.2992 95.437 66.6657 95.6648 66.012 95.6648C65.3582 95.6648 64.7248 95.437 64.2203 95.0205C63.7157 94.6039 63.3715 94.0245 63.2466 93.3816C63.1217 92.7387 63.2239 92.0723 63.5357 91.4966C63.8474 90.9209 64.3493 90.4717 64.9553 90.226V18.546C64.3441 18.305 63.8364 17.8571 63.5205 17.2801C63.2046 16.7031 63.1004 16.0335 63.2259 15.3875C63.3515 14.7415 63.6989 14.16 64.2078 13.744C64.7168 13.3279 65.3551 13.1035 66.012 13.1099ZM66.012 11.8299C65.1379 11.826 64.2856 12.1028 63.5801 12.6198C62.8746 13.1367 62.353 13.8666 62.0919 14.7023C61.8308 15.538 61.844 16.4355 62.1293 17.2632C62.4147 18.0909 62.9574 18.8052 63.6777 19.3012V89.4721C62.9609 89.9703 62.4217 90.6848 62.1387 91.5115C61.8556 92.3382 61.8434 93.2338 62.104 94.0679C62.3645 94.902 62.8841 95.6309 63.5871 96.1484C64.29 96.666 65.1396 96.9451 66.012 96.9451C66.8843 96.9451 67.7339 96.666 68.4369 96.1484C69.1398 95.6309 69.6594 94.902 69.92 94.0679C70.1805 93.2338 70.1683 92.3382 69.8853 91.5115C69.6022 90.6848 69.063 89.9703 68.3462 89.4721V19.3012C69.0665 18.8052 69.6092 18.0909 69.8946 17.2632C70.18 16.4355 70.1931 15.538 69.932 14.7023C69.6709 13.8666 69.1493 13.1367 68.4438 12.6198C67.7383 12.1028 66.886 11.826 66.012 11.8299Z"
      fill={colors.purple100}
    />
  </SvgIcon>
);
